import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
class VoiceRoomVideoProvider {
  list = [];
  isPlaying = false;
  addVideo(src) {
    if (src) {
      this.list.push(src);
    }
  }
  playEnd() {
    this.list.shift();
    this.isPlaying = false;
    this.play();
  }

  play() {
    if (!this.isPlaying) {
      if (this.list[0]) {
        this.isPlaying = true;
        VoiceRoomEventEmitter.emit(VoiceRoomEvent.playVideo, this.list[0]);
      }
    }
    return this.isPlaying;
  }
  playNow(src) {
    console.log(src);
    this.addVideo(src)
    VoiceRoomEventEmitter.emit(VoiceRoomEvent.playVideo, src);
  }
}
const videoProvider = new VoiceRoomVideoProvider();
VoiceRoomEventEmitter.on(VoiceRoomEvent.addVideoMessage, src => {
  videoProvider.addVideo(src);
  videoProvider.play();
});
export default videoProvider;
